module.exports = __webpack_public_path__ + "img/chat-ico.62d2a313.svg";